export interface Vendor {
  id: string;
  name: string;
  category: VendorCategory;
  description: string;
  shortDescription: string;
  image: string;
  gallery: string[];
  location: string;
  priceRange: PriceRange;
  rating: number;
  reviewCount: number;
  featured: boolean;
  services: string[];
  contactEmail: string;
  contactPhone: string;
  website?: string;
}

export type VendorCategory = 
  | 'venue'
  | 'catering'
  | 'photography'
  | 'videography'
  | 'music'
  | 'flowers'
  | 'decoration'
  | 'dress'
  | 'cake'
  | 'invitation'
  | 'makeup'
  | 'transport';

export type PriceRange = 'budget' | 'moderate' | 'premium' | 'luxury';

export interface VendorCategoryInfo {
  id: VendorCategory;
  name: string;
  icon: string;
  description: string;
}

export const VENDOR_CATEGORIES: VendorCategoryInfo[] = [
  { id: 'venue', name: 'Lugares', icon: '🏰', description: 'Fincas, hoteles y espacios únicos' },
  { id: 'catering', name: 'Catering', icon: '🍽️', description: 'Gastronomía para tu gran día' },
  { id: 'photography', name: 'Fotografía', icon: '📸', description: 'Captura cada momento especial' },
  { id: 'videography', name: 'Vídeo', icon: '🎬', description: 'Tu historia en movimiento' },
  { id: 'music', name: 'Música', icon: '🎵', description: 'DJs, bandas y orquestas' },
  { id: 'flowers', name: 'Floristería', icon: '💐', description: 'Arreglos florales y ramos' },
  { id: 'decoration', name: 'Decoración', icon: '✨', description: 'Ambientación y detalles' },
  { id: 'dress', name: 'Vestidos', icon: '👗', description: 'El vestido de tus sueños' },
  { id: 'cake', name: 'Tarta', icon: '🎂', description: 'Pasteles y dulces' },
  { id: 'invitation', name: 'Invitaciones', icon: '💌', description: 'Papelería y diseño' },
  { id: 'makeup', name: 'Belleza', icon: '💄', description: 'Maquillaje y peluquería' },
  { id: 'transport', name: 'Transporte', icon: '🚗', description: 'Coches clásicos y limusinas' },
];

export const PRICE_RANGE_LABELS: Record<PriceRange, string> = {
  budget: '€',
  moderate: '€€',
  premium: '€€€',
  luxury: '€€€€',
};
